import React, { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { Styles, Icon } from '@contently/toolkit';

const StyledSelectContainer = styled('div')`
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 28px;
  margin-right: 9px;
  margin-bottom: 7px;
  padding: 3px 28px 0 8px;
`;
const StyledSelection = styled('div')`
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  height: inherit;
  line-height: 28px;
`;
const StyledOptions = styled('ul')`
  position: absolute;
  left: -6px;
  top: 37px;
  min-width: 180px;
  width: auto;
  background: ${Styles.colors.white};
  padding: 0;
  margin: 0;
  border-radius: 0 0 3px 3px;
  border: 1px solid ${Styles.colors.grey.secondary};
  box-shadow: ${Styles.colors.grey.secondary} 0 0 4px 0;
  z-index: ${Styles.zindex.component.aboveBase};
`;
const StyledOption = styled('li')`
  background: ${props => (props['aria-selected'] ? Styles.colors.blue.secondaryLight : '')};
  width: 180px;
  list-style: none;
  padding: 6px 11px;
  margin: 0;
  cursor: pointer;
  * {
    margin: 0;
  }
  &:hover,
  &:focus {
    background: ${Styles.colors.blue.secondary};
  }
`;
const StyledIcon = styled(Icon)`
  position: absolute;
  right: 0;
`;
const optionNameMap = {
  p: () => <p>Paragraph</p>,
  H1: () => <h1>Heading 1</h1>,
  H2: () => <h2>Heading 2</h2>,
  H3: () => <h3>Heading 3</h3>,
  H4: () => <h4>Heading 4</h4>,
  H5: () => <h5>Heading 5</h5>,
  H6: () => <h6>Heading 6</h6>
};

function FormatSelect({ options }) {
  const [selectedValue, setSelectedValue] = useState('p');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const node = useRef(null);

  function handleChange(option) {
    option.editorView.focus();
    option.command(option.editorView.state, option.editorView.dispatch, option.editorView);

    setDropdownOpen(false);
    setSelectedValue(option.name);
  }

  const activeItem = options.find(option => option.status === 'active');
  useEffect(() => {
    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  });
  useEffect(() => {
    if (activeItem) {
      setSelectedValue(activeItem.name);
    }
  }, [activeItem && activeItem.name]);

  const handleClick = e => {
    if (node.current.contains(e.target)) {
      return;
    }

    setDropdownOpen(false);
  };

  return (
    <StyledSelectContainer
      onClick={() => setDropdownOpen(!dropdownOpen)}
      aria-label="header-dropdown"
      ref={node}
    >
      <StyledSelection>
        {optionNameMap[selectedValue]().props.children}
        <StyledIcon type={dropdownOpen ? 'angle-up' : 'angle-down'} />
      </StyledSelection>
      {dropdownOpen && (
        <StyledOptions aria-label="header-dropdown-options">
          {options.map(option => (
            <StyledOption
              key={option.name}
              aria-selected={selectedValue === option.name}
              onClick={() => handleChange(option)}
            >
              {optionNameMap[option.name]()}
            </StyledOption>
          ))}
        </StyledOptions>
      )}
    </StyledSelectContainer>
  );
}

export default FormatSelect;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/menus/topMenu/FormatSelect.jsx